/**
 * Per-SKU example carousel folder mapping.
 *
 * Examples live in R2 at:
 *   <R2_PUBLIC_BASE>/examples/<folder>/example-1.webp
 *   <R2_PUBLIC_BASE>/examples/<folder>/example-2.webp
 *   ...
 *
 * The miniapp probes indices starting from 1 and stops at the first 404 —
 * so adding more examples is a pure R2 upload (no deploy required).
 */
export const SKU_EXAMPLES_FOLDER: Readonly<Record<string, string>> = {
  avatar_mini: 'mini-9',
  avatar_max: 'max-16',
  zodiac_collection: 'zodiac-12',
  past_lives_pack: 'past-lives-1',
  couple_portrait: 'couple-1',
  couple_portrait_upsell: 'couple-1',
  compat_check: 'compat-1',
  gifting_crush: 'gift-2',
  lucky_14: 'lucky-1',
  lucky_30: 'lucky-1',
  natal_theme: 'natal-1',
  natal_bundle: 'natal-1',
};

const FALLBACK_R2_BASE = 'https://cdn.calestea.com';

export function getR2PublicBase(): string {
  return (
    (import.meta.env['VITE_R2_PUBLIC_BASE_URL'] as string | undefined) ?? FALLBACK_R2_BASE
  ).replace(/\/+$/, '');
}

export function exampleUrl(folder: string, index: number): string {
  return `${getR2PublicBase()}/examples/${folder}/example-${index}.webp`;
}

export function getExamplesFolderForSku(skuCode: string): string | null {
  return SKU_EXAMPLES_FOLDER[skuCode] ?? null;
}
